import "./ContactUs.css";
import { useState } from "react";
import { Helmet } from "react-helmet-async";

const ContactUs = ({ dark }) => {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log(formData);

    alert("Message submitted successfully!");
  };

  return (
    <div className={`contact-page ${dark ? "dark" : "light"}`}>
      <Helmet>
        <title>Contact Us | FadaSports - Support & Business Inquiries</title>
        <meta name="description" content="Get in touch with FadaSports. Contact us for support, feedback, partnership opportunities, sponsorships, or business inquiries." />
        <meta name="keywords" content="contact us, support, feedback, partnership, sponsorship, business inquiry" />
        <meta name="author" content="FadaSports" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Contact FadaSports" />
        <meta property="og:description" content="Reach out to FadaSports for support, partnerships, and inquiries." />
        <meta property="og:image" content="https://fadasports.com/static/media/mobilelogo.d0257d49e02d3094cce0.png" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="FadaSports" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@FadaSports" />
      </Helmet>

      <section className="contact-hero">

        <div className="contact-overlay">

          <span className="contact-tag">
            FadaSports Support
          </span>

          <h1>
            Let’s Talk Sports, Partnerships & Support
          </h1>

          <p>
            Have questions, feedback, business inquiries, partnership
            opportunities, or support requests? Reach out to the
            FadaSports team and we’ll get back to you as soon as possible.
          </p>

        </div>

      </section>

      <section className="contact-main">

        <div className="contact-grid">

          <div className="contact-left">

            <div className="contact-info-card">

              <h2>Contact Information</h2>

              <p>
                We are always open to hearing from football fans,
                brands, partners, creators, and sports enthusiasts
                worldwide.
              </p>

              <div className="contact-info-list">

                <div className="contact-info-item">
                  <div className="contact-icon">
                    ✉️
                  </div>

                  <div>
                    <h3>Email Support</h3>

                    <a href="mailto:support@fadasports.com">
                      support@fadasports.com
                    </a>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-icon">
                    📢
                  </div>

                  <div>
                    <h3>Advertising & Partnerships</h3>

                    <a href="mailto:adverts@fadasports.com">
                      adverts@fadasports.com
                    </a>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-icon">
                    ⚽
                  </div>

                  <div>
                    <h3>Platform Focus</h3>

                    <p>
                      Sports Media, Analytics, Statistics &
                      Football Intelligence
                    </p>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-icon">
                    🌍
                  </div>

                  <div>
                    <h3>Global Audience</h3>

                    <p>
                      Serving football and sports fans across
                      Africa and beyond
                    </p>
                  </div>
                </div>

              </div>

            </div>

            <div className="contact-extra-card">

              <h2>Why Contact FadaSports?</h2>

              <div className="extra-grid">

                <div className="extra-box">
                  <h3>Support</h3>

                  <p>
                    Need help using the platform or managing your
                    account? Our support team is ready to assist.
                  </p>
                </div>

                <div className="extra-box">
                  <h3>Partnerships</h3>

                  <p>
                    Interested in working with FadaSports on
                    campaigns, sponsorships, or collaborations?
                  </p>
                </div>

                <div className="extra-box">
                  <h3>Media Inquiries</h3>

                  <p>
                    Reach out for press, interviews, editorial,
                    or sports media opportunities.
                  </p>
                </div>

                <div className="extra-box">
                  <h3>Feedback</h3>

                  <p>
                    Share ideas, feature requests, or suggestions
                    to help improve the FadaSports experience.
                  </p>
                </div>

              </div>

            </div>

          </div>

          {/* <div className="contact-right">

            <form
              className="contact-form"
              onSubmit={handleSubmit}
            >

              <div className="form-header">
                <h2>Send Us A Message</h2>

                <p>
                  Fill out the form below and our team will
                  respond shortly.
                </p>
              </div>

              <div className="form-group">
                <label>Full Name</label>

                <input
                  type="text"
                  name="name"
                  placeholder="Enter your full name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Email Address</label>

                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email address"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Subject</label>

                <input
                  type="text"
                  name="subject"
                  placeholder="What would you like to discuss?"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Message</label>

                <textarea
                  name="message"
                  rows="7"
                  placeholder="Write your message here..."
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit">
                Send Message
              </button>

            </form>

          </div> */}

        </div>

      </section>

    </div>
  );
};

export default ContactUs;